import { createNotifications } from '@gokrew/ui/components';
import { notificationHooks } from '@/hooks/useNotifications';
import { resolveNotificationHref } from '@/utility/notifications';

const Notifications = createNotifications({
  hooks: notificationHooks,
  resolveHref: resolveNotificationHref,
});

export default Notifications;
